import { Pressable } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";

export type TrafficFlowViewMode = "grid" | "map";

interface ViewModeToggleProps {
  value: TrafficFlowViewMode;
  onChange: (next: TrafficFlowViewMode) => void;
}

const OPTIONS: { value: TrafficFlowViewMode; label: string; icon: "list" | "map" }[] = [
  { value: "grid", label: "Grid", icon: "list" },
  { value: "map", label: "Setup", icon: "map" },
];

export function ViewModeToggle({ value, onChange }: ViewModeToggleProps) {
  const { theme } = useUnistyles();

  return (
    <View
      style={{
        flexDirection: "row",
        borderWidth: 1,
        borderColor: theme.colors.borderCard,
        borderRadius: theme.spacing.md,
        overflow: "hidden",
        alignSelf: "flex-start",
      }}
    >
      {OPTIONS.map((opt, index) => {
        const isSelected = value === opt.value;
        return (
          <Pressable
            key={opt.value}
            onPress={() => onChange(opt.value)}
            accessibilityRole="button"
            accessibilityState={{ selected: isSelected }}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing.xs,
              paddingVertical: theme.spacing.lg,
              paddingHorizontal: theme.spacing["3xl"],
              backgroundColor: isSelected ? theme.colors.icon : "transparent",
              borderLeftWidth: index === 0 ? 0 : 1,
              borderLeftColor: theme.colors.borderCard,
            }}
          >
            <Icon
              name={opt.icon}
              size={theme.spacing["4xl"]}
              color={isSelected ? theme.colors.background : theme.colors.text}
            />
            <Text textStyle={isSelected ? "sm/semibold" : "sm/regular"} color={isSelected ? "background" : "text"}>
              {opt.label}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}
